import { Component, Input } from '@angular/core';
import { ColDef, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridOptionsBuilder, AgGridFilterParams, AgGridColumns } from '../../../Compliance/AgGrid';
import { WeissmanTimestampMsecFormatPipe } from '../../../UI-Lib/Pipes/Date-Format/date-formatting.pipe';

@Component({
    selector: 'data-hub-log-details-grid',
    template: `
        <ws-ag-grid-angular class="ag-theme-balham grid grid-cell-no-focus"
                            [gridOptions]="gridOptions"
                            [forceShowToolPanel]="true"
                            [showConfigureLayout]="false"
                            [defaultSizeToFit]="false"
                            [defaultSizeToContent]="true"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
    `,
    standalone: false
})

export class DataHubLogDetailsGridComponent {
    constructor(private readonly _datePipe: WeissmanTimestampMsecFormatPipe) {
    }

    @Input() detailLogs: Core.DataHubDetailLogModel[];

    gridOptions: GridOptions = new AgGridOptionsBuilder({
        suppressScrollOnNewData: true
    })
        .withContext(this)
        .withLoadingOverlay()
        .withColumnResize()
        .withTextSelection()
        .build();

    private _gridApi: GridApi;

    onAgGridReady(event: GridReadyEvent): void {
        this._gridApi = event.api;

        const columns: ColDef[] = [
            {
                headerName: 'Detail ID',
                field: 'dataHubDetailLogId',
                width: AgGridColumns.numericColumnWidth
            },
            {
                headerName: 'Log Time',
                field: 'logTime',
                width: AgGridColumns.dateColumnWidth,
                sortable: false,
                valueFormatter: (params) => {
                    const model = params.data as Core.DataHubDetailLogModel;
                    if (!(model && model.logTime)) {
                        return '';
                    }

                    return this._datePipe.transform(model.logTime);
                }
            },
            {
                headerName: 'Message',
                field: 'message',
                width: AgGridColumns.textColumnLargeWidth,
                filter: 'agTextColumnFilter',
                filterParams: AgGridFilterParams.textFilterParams,
                floatingFilterComponentParams: AgGridFilterParams.textFloatingFilterParams,
                sortable: false
            }
        ];

        this._gridApi.setGridOption('columnDefs', columns);
        this._gridApi.sizeColumnsToFit();

        this.setRowData();
    }

    setRowData() {
        if (!(this._gridApi && this.detailLogs)) {
            return;
        }

        this._gridApi.setGridOption('rowData', this.detailLogs);
    }
}
